import styles from './ReadSpeaker.css';

export default ($node: HTMLElement) => {
	const $link = $node.querySelector('[data-select="readspeakerlink"]');

	if ($link instanceof HTMLAnchorElement) {
		//$link.href = $link.href + encodeURIComponent(window.location.href + '?p=main&l=de_de');
	}

	const getCookie = (name: string) => {
		const cookieName = name + '=';
		const cookieDecoded = decodeURIComponent(document.cookie);
		const cookieArray = cookieDecoded.split('; ');

		let result;

		cookieArray.forEach(cookie => {
			if (cookie.indexOf(cookieName) === 0) {
				result = (cookie.substring(cookieName.length) === 'true');
			}
		})

		return result;
	}

	if (getCookie('read_speaker')) {
		$node.classList.remove(styles.isHidden)
	}
}
